import get from 'lodash/get'

export default {
  categories() {
    return get(window, '__appState.cached_state.categories', null)
  },

  cities() {
    return get(window, '__appState.cached_state.cities', null)
  },

  offers() {
    return get(window, '__appState.cached_state.offers', null)
  },

  product() {
    return get(window, '__appState.cached_state.product', null)
  },

  store() {
    return get(window, '__appState.cached_state.store', null)
  },

  /**
   * Returns true if website was loaded via prerender service.
   *
   * @return {boolean}
   */
  prerendering() {
    return get(window, '__appState.custom_context.prerendering', null) === true
  },
}
